<div class="form-horizontal" [formGroup]="pollinationInstructions">
  <div class="form-group" [class.has-error]="pollinationCategory.invalid">
    <label class="control-label col-sm-3 text-nowrap">Pollination Category
      <ng-template #pollinationCategoryTooltip>
        <span [innerHtml]="pollinationCategoryTooltipText" style="text-align: left; display: block;"></span>
      </ng-template>
      <a [tooltip]="pollinationCategoryTooltip"
         placement="right"
         container="body">
        <span class="glyphicon glyphicon-info-sign"></span>
      </a>
    </label>
    <span class="col-sm-2">
      <select formControlName="pollinationCategory" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of pollinationCategoryOptions" [ngValue]="option.id">{{ option.name }}</option>
      </select>
    </span>
  </div>
  <div class="form-group" *ngIf="showPollinationInstructions">
    <div class="col-sm-3">
      <div class="form-group text-center" *ngIf="canAddPreferenceGroup">
        <button class="btn btn-success" type="button" (click)="addPreferenceGroup()">Add Instructions</button>
        <ng-template #openTooltip><div class="pollination_tooltip">This button adds a new group of pollination instructions. Limit pollination instructions to a primary and if necessary, a secondary instruction. For more information on how to format your instructions, reference <a href="https://agcompany.sharepoint.com/:f:/s/BiotechEventGovernanceBoard/Eq3l-VuLwRFLijxeKFWqfv8BUgONDS8QeAY1rp0yTC6tCw?e=bLuC1O" target="_blank">the Pollination Playbook</a>.</div></ng-template>
        <span class="glyphicon glyphicon-info-sign"
              [tooltip]="openTooltip"
              placement="right"
              triggers="mouseenter:click"
              container="body"></span>
      </div>
      <div class="panel panel-default panel-body" *ngIf="pollinationPreferences.length > 0 && focusedPreference >= 0">
        <div class="row" *ngFor="let type of ceRequestOptions.pollinationTypes">
          <div class="col-sm-9">
            {{ type.name }}
          </div>
          <div class="col-sm-3">
            <i class="fa fa-arrow-circle-right fa-2x"
               (click)="addInstruction(type.id)"
               [class.text-muted]="!canAddPollinationInstruction(focusedPreference, type.id)"
               [style.pointer-events]="canAddPollinationInstruction(focusedPreference, type.id) ? 'auto' : 'none'"
               aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-9">
      <div class="ngx-dnd-container"
           [class.zygosity-container]="isZygosityDependent()"
           [model]="pollinationPreferences.controls"
           (drop)="dropped($event)"
           ngxDroppable>
        <div class="ngx-dnd-item has-handle"
             [model]="preferenceGroup"
             formArrayName="pollinationPreferences"
             *ngFor="let preferenceGroup of pollinationPreferences.controls; let i = index"
             ngxDraggable>
          <app-pollination-preference-group [preferenceGroup]="preferenceGroup"
                                            [index]="i"
                                            [preferenceCount]="pollinationPreferences.length"
                                            [focused]="focusedPreference === i"
                                            [canDelete]="canDeletePreferenceGroup"
                                            [groupLabel]="getGroupLabel(i)"
                                            [shouldHideConjunction]="shouldHideConjunction(i)"
                                            (onDelete)="delete($event)"
                                            (onDeleteLastItem)="deleteLastItemFromGroup($event)"
                                            (onFocus)="focus($event)">
          </app-pollination-preference-group>
        </div>
      </div>
      <div class="alert alert-danger" *ngIf="pollinationPreferences.errors?.required">
        Please specify pollination preferences
      </div>
    </div>
  </div>

  <app-pollination-stake-label [pollinationInstructions]="pollinationInstructions"></app-pollination-stake-label>

  <div class="form-group" [class.has-error]="donorsNeeded.invalid" *ngIf="showDonorNeeded">
    <label class="control-label col-sm-2">
      Donors Needed?
      <a [tooltip]="tooltipMessage"
         placement="right"
         container="body">
        <span class="glyphicon glyphicon-info-sign"></span>
      </a>
    </label>
    <span class="col-sm-9">
      <ui-switch formControlName="donorsNeeded" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
    </span>
  </div>

</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-instructions.component.html